export default __webpack_public_path__ + "svg/777db597f8acb936c311c10fe5751079.svg";